import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorResolver: FieldResolver = (metadata: Metadata) =>
  ({ author: metadata.getAuthor() } as StreamData)

export default authorResolver
